class InlineVideo extends HTMLElement {
  constructor() {
    super();

    this.src = this.getAttribute('data-src');
    this.aspectRatio = this.getAttribute('data-aspect-ratio');

    this.buildVideo();
  }

  buildVideo() {
    let video = document.createElement('video');
    video.src = this.src;
    video.muted = true;
    video.playsinline = true;
    video.loop = true;

    const self = this;
    video.onloadeddata = function(){
      self.append(video);

      console.log(video.play());
    }
  }
}

customElements.define('inline-video', InlineVideo);